import React, { useMemo } from 'react';
import StaffPanelBanner from './StaffPanelBanner';
import StaffPanelNav from './StaffPanelNav';
import { StaffPanelContext } from './StaffPanelContext';

function StaffPanelLayout({ userData, children }) {
    const panel = useMemo(() => ({ inPanel: true, userData }), [userData]);

    return (
        <StaffPanelContext.Provider value={panel}>
            <div className="flex min-h-screen flex-col bg-coal_dark">
                <StaffPanelBanner userData={userData} />
                <StaffPanelNav userData={userData} />

                <div className="w-full flex-1 bg-white/5">
                    <div className="mx-auto w-full max-w-[1400px] px-4 py-5">
                        {children}
                    </div>
                </div>
            </div>
        </StaffPanelContext.Provider>
    );
}

export default StaffPanelLayout;
